import React from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import OpenCartButton from './OpenCartButton';

const OpenCart = () => (
  <Provider store={store}>
    <OpenCartButton />
  </Provider>
);

export default OpenCart;
